import { INITIAL_DATA_SHIPPING } from '../constants/shippingEditConstants';

export const createShippingInitialState = (id, employee) => {
  const initial = { ...INITIAL_DATA_SHIPPING, linesshipping: [] };
  if (String(id) !== '0') return initial;

  initial.date_shipping = new Date();
  initial.vehiclestore_trailer = 'SIN REMOLQUE';
  const vehicles = Array.isArray(employee?.vehiclestore) ? employee.vehiclestore : [];
  const vehicle = vehicles.find((item) => item?.vehiclestore_licenseplate?.trim());
  if (!vehicle) return initial;

  return {
    ...initial,
    vehiclestore_id: vehicle.vehiclestore_id || 0,
    vehiclestore_licenseplate: vehicle.vehiclestore_licenseplate.trim(),
    vehiclestore_defaultdriver: employee.fullname || '',
    vehiclestore_documentid: employee.numberdocument || '',
  };
};
